import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import styled, { keyframes, css } from "styled-components";

/* ---------- Drop-in bold that always shows bolder ---------- */
export const Strong = styled.span`
  font-weight: 900 !important; /* force heavy */
  font-variation-settings: "wght" 900; /* for variable fonts */
  font-synthesis-weight: none; /* avoid fake bold */
`;

const showMessageAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const MessageWrapper = styled(Alert)`
  font-size: 17px;
  border: none;
  font-weight: 0;
  background-color: ${(props) => props.color} !important;
  ${({ show }) =>
    show &&
    css`
      animation: ${showMessageAnimation} 0.5s ease-in-out;
    `}
`;

function Messages({ variant, color, children }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <MessageWrapper variant={variant} color={color} show={show}>
      {children}
    </MessageWrapper>
  );
}

export default Messages;
